export default theme => ({
  header: {
    height: '200px',
    marginTop: '30px',
    background: theme.palette.white.main,
    display: 'flex',
    flexDirection: 'row',
  },
});
